import { trackPageLoad } from './trackers/trackPageLoad';

function safelyDecodeURIComponent(str) {
  try {
    return decodeURIComponent(str);
  } catch (e) {
    return str;
  }
}

function getWindowHash() {
  const hash = window.location.hash.substr(7);
  const decodedHash = safelyDecodeURIComponent(hash);
  return JSON.parse(decodedHash);
}

function goToHash(viewerApp) {
  if (!window.location.hash) {
    return;
  }
  const dest = getWindowHash();
  viewerApp.goToDestination(dest);
}

export default function pdfDidRender(viewerApp) {
  goToHash(viewerApp);
  trackPageLoad();
}
